/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../Action/snackbarAction";
import { showErrorSnackbar } from "../Action/snackbarAction";
import { optionTypeImage, optionTypeText } from "../Utils/dataConstants";
import TextEditor from "../Screen/DataEntryPanel/CreateQuestion/textEditor";
import ImagePickerAndViewer from "../Component/imagePickerAndViewer";
import { uploadQuestionImage } from "../Action/courseAction";
import { image_size_150, validateIsFileImageType } from "../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../Utils/errorMsg";

function OptionMSQ(props) {
  const dispatch = useDispatch();
  const { index, setOptionData, option,maxLength,isSetWordCount } = props;
  const [isCorrect, setIsCorrect] = useState(false);
  const [options, setOptions] = useState({});
  const [desctiption, setDesctiption] = useState("");
  const [desctiptionType, setDesctiptionType] = useState("");
  const [optionImage, setOptionImage] = useState("");
  useEffect(() => {
    if (option) {
      setOptions(option);
      const { descType, description, isCorrect } = option;
      const data = String(description);
      const removeData = data.replace(/\\n/g, " ");
      const modifiedHtml = removeData.replace(/\\t/g, " ");
      setDesctiption(modifiedHtml);
      setOptionImage(description);
      setIsCorrect(isCorrect);
      setDesctiptionType(descType);
    }
  }, []);

  const handleOptionImageChange = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_150) {
      dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setOptionImage(reader.result);
      };
      reader.readAsDataURL(file);

      dispatch(
        uploadQuestionImage(
          file,
          (res) => {
            if (res?.media) {
              dispatch(showSuccessSnackbar("File Succesfully Uploaded"));
              setOptionsValue(res?.media, isCorrect);
            } else {
              dispatch(showErrorSnackbar("File Not Uploaded"));
            }
          },
          () => {}
        )
      );
    }
  };
  const showMenu = (obj) => {
    if (obj === "text") {
      setOptions(optionTypeText);
      setDesctiptionType("text");
    } else {
      setOptions(optionTypeImage);
      setDesctiptionType("img");
    }
  };

  const setOptionsValue = (val, radioval) => {
    const PostData = {
      descType: desctiptionType,
      description: val,
      isCorrect: radioval,
    };
    setOptionData(PostData);
    return PostData;
  };

  const onChangeRadio = (val) => {
    setIsCorrect(val);
    setOptionsValue(desctiption, val);
  };

  const onChangeText = (val) => {
    setDesctiption(val);
    setOptionsValue(val, isCorrect);
  };

  return (
    <div>
      <div className="CreateQuestionTitle d-flex justify-content-between">
        <h5 className="admitCardHeading text-left d-flex ">
          Option {index + 1}
        </h5>
        <div className="correctOption-check d-flex align-items-center p-2">
          <span className="me-3" style={{ color: "var(--purple)" }}>
            Correct Option
          </span>
          <input
            type="Checkbox"
            label="Correct option"
            name="correct"
            checked={isCorrect}
            onChange={(value) => onChangeRadio(value.target.checked)}
          />
        </div>
        <div className=" d-flex">
          <div
            className="cursor addInputbtn ms-2 p-1"
            onClick={() => showMenu("text")}
          >
            + Text
          </div>
          {!props?.noImage &&<div
            className="cursor addInputbtn ms-2 p-1"
            onClick={() => showMenu("img")}
          >
            + Image
          </div>}
        </div>
      </div>

      <div className="col-auto">
        {options?.descType === "text" ? (
          <div className="editor_content mb-2">
            <TextEditor
              setInputText={(value) => onChangeText(value)}
              value={desctiption}
               isSetWordCount={isSetWordCount}
              maxLength={maxLength}
            />
          </div>
        ) : options?.descType === "img" ? (
          <div className="mb-2">
            <ImagePickerAndViewer
              labelName={"Option Image"}
              value={optionImage}
              handleChange={(e) => handleOptionImageChange(e, index)}
              htmlFor={`msq-photo-upload ${index}`}
              Isrequired={true}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default OptionMSQ;
